<template>
  <div id="statisticalProduct">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'statisticalProduct'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/statistical/exhibition/product/StatisProduct.vue